import { takeLatest, put } from 'redux-saga/effects';
import {
  GET_CUBE_PAYMENT_DUE_REQUEST,
  GET_CUBE_PAYMENT_DUE_SUCCESS,
  SET_CUBE_PAYMENT_LOADING,
} from 'redux/reducers/payment/actionTypes';

function* requestCubePaymentDue(action) {
  const location =
    action && action.params && action.params.location
      ? action.params.location
      : null;
  let params = action.params;
  delete params.location;
  action.params = params;

  if (location === null) {
    yield put({ type: SET_CUBE_PAYMENT_LOADING });
  }

  yield put({ type: GET_CUBE_PAYMENT_DUE_SUCCESS, result: action.params });
}
function* getCubePaymentDue() {
  yield takeLatest(GET_CUBE_PAYMENT_DUE_REQUEST, requestCubePaymentDue);
}

export default getCubePaymentDue;
